import counterUp from 'counterup2';
require('waypoints/lib/noframework.waypoints.js');

const couters = document.querySelectorAll( '.counter' )
for (let i = 0; i < couters.length; i++) {
    let el = couters[i];
    new Waypoint( {
        element: el,
        handler: function() {
            counterUp( el )
            this.destroy()
        },
        offset: 'bottom-in-view',
    } )
}
